/* eslint-disable */
export const isBrowser = (typeof process !== 'undefined' && (process as any).browser) || typeof window.document !== 'undefined'
